import gql from 'graphql-tag'

export default gql`query search_clients($query: String!){
  search_clients(name: $query){
    client_id
    name
    client_addresses{
      address_id
      abode_name_no
      building_no
      street
      city
      county
      postcode
      full_address
      name
    }
    client_contacts{
        contact_id
        first_name
        last_name
        position
        contact_communication_methods{
            contact_info
            contact_medium{
                contact_medium_id
                description
            }
        }
    }
  }
}`